import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'InfoCard',
  props: {
  bodyClass: {
    type: String,
    default: ""
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_BCard = _resolveComponent("BCard")!

  return (_openBlock(), _createBlock(_component_BCard, {
    "body-class": __props.bodyClass,
    "bg-variant": "primary-bg",
    "border-variant": "primary-yellow"
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ], undefined, true),
    _: 3
  }, 8, ["body-class"]))
}
}

})